import React from "react";
import Flagship from "../../core/flagship";
import { connect } from "react-redux";
import { browserHistory, Link } from "react-router";
import Field from "../misc/Field";
import IoProductFields from "../misc/IoProductFields";
import SingleRecordHeader from "../misc/SingleRecordHeader";
import {
  Table,
  Loader,
  Button,
  Header,
  Segment,
  Grid,
  Label,
  Icon,
  Modal,
} from "semantic-ui-react";
import {
  setAsyncRouteLeaveHook,
  throttle,
  shouldShowField,
  empty,
  clean,
} from "../../utils/helpers";

class CreateRecord extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onSubmit = this.onSubmit.bind(this);
    this.cancelExit = this.cancelExit.bind(this);
    this.saveRecord = this.saveRecord.bind(this);
    this.abandonChanges = this.abandonChanges.bind(this);
    this.showLeaveConfirmation = this.showLeaveConfirmation.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeMarket = this.onChangeMarket.bind(this);
    this.maybeRenderExtra1 = this.maybeRenderExtra1.bind(this);
    this.maybeRenderExtra2 = this.maybeRenderExtra2.bind(this);
    this.onChangeExtra1 = this.onChangeExtra1.bind(this);
    this.onChangeExtra2 = this.onChangeExtra2.bind(this);
    this.onChangeExtra3 = this.onChangeExtra3.bind(this);
    this.onChangeExtra4 = this.onChangeExtra4.bind(this);
    this.onChangeProductData = this.onChangeProductData.bind(this);
    this.checkRequired = this.checkRequired.bind(this);
    this.onChildRequiredMissing = this.onChildRequiredMissing.bind(this);
    this.maybeRenderExtra3 = this.maybeRenderExtra3.bind(this);
    this.timer = null;
    this.routeType = !empty(this.props.route)
      ? this.props.route.type
      : "client";
    this.type = !empty(this.props.type) ? this.props.type : this.routeType;
    this.niceName = !empty(this.props.niceName)
      ? this.props.niceName
      : this.props.route.niceName;
  }

  getInitialState() {
    return {
      confirmExit: false,
      recordFields: [],
      name: "",
      extra1: "",
      extra2: "",
      extra3: "",
      extra4: "",
      fieldData: [],
      isAdvisr: false,
      modified: false,
      nextLocation: "",
      validName: true,
      nameValidationMessage: "",
      requiredMissing: true,
      childRequiredMissing: false,
      errors: [],
      formTemplate: this.props.formTemplate,
      selectedMarket: null,
      parent: null,
    };
  }

  componentWillMount() {
    setTimeout(Flagship.closeSidebarNav, 500);
    if (!empty(this.props.router)) {
      setAsyncRouteLeaveHook(
        this.props.router,
        this.props.route,
        this.routerWillLeave.bind(this)
      );
    }
  }

  componentDidMount() {
    document.title = this.niceName + " / New";
    if (!empty(this.props.formTemplate.extra1)) {
      this.setState(
        {
          extra1: this.props.formTemplate.extra1,
          selectedMarket: this.props.formTemplate.extra1.market,
        },
        Flagship.clearFormTemplate
      );
    }
    this.getRecordFields();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.instance !== nextProps.instance) {
      this.setState(this.getInitialState(), this.getRecordFields);
    }
  }

  componentDidUpdate() {
    this.routeType = !empty(this.props.route)
      ? this.props.route.type
      : "client";
    if (this.hasOwnProperty("type") && this.type !== this.routeType) {
      this.setState(this.getInitialState(), this.getRecordFields);
      this.timer = null;
      this.type = !empty(this.props.type)
        ? this.props.type
        : this.props.route.type;
      this.niceName = !empty(this.props.niceName)
        ? this.props.niceName
        : this.props.route.niceName;
      document.title = this.niceName + " / New";
    }

    if (this.state.selectedMarket === null) {
      this.setState({
        selectedMarket: this.props.userMarket,
      });
    }
  }

  routerWillLeave(url) {
    let modified = this.props.modified;
    let showLeaveConfirmation = this.showLeaveConfirmation;
    return new Promise((resolve) => {
      if (!modified) {
        // No unsaved changes -- leave
        resolve(true);
      } else {
        // Unsaved changes -- ask for confirmation
        showLeaveConfirmation(url);

        resolve(false);
      }
    });
  }

  addError(fieldId) {
    let errors = this.state.errors;

    if (errors.indexOf(fieldId) === -1) {
      errors.push(fieldId);
    }

    this.setState({
      errors: errors,
    });
  }

  clearError(fieldId) {
    let errors = this.state.errors;
    for (var i = errors.length - 1; i >= 0; i--) {
      if (errors[i] === fieldId) {
        errors.splice(i, 1);
      }
    }

    this.setState({
      errors: errors,
    });
  }

  getRecordFields() {
    let self = this;

    Flagship.get(
      "fields/" + this.type,
      {
        active: true,
        context: "record",
        instance: self.props.instance,
      },
      function (response) {
        if (response.data.success === true) {
          self.setState({
            recordFields: response.data.results,
          });
        }
      },
      function (err) {
        Flagship.error(
          "Error getting fields to create new record: " + err,
          0,
          self.props.userId
        );
      }
    );
  }

  checkRequired() {
    let requiredMissing = false;
    let self = this;

    if (self.state.name === "") {
      requiredMissing = true;
    }

    if (self.state.selectedMarket === "") {
      requiredMissing = true;
    }

    if (self.state.childRequiredMissing === true) {
      requiredMissing = true;
    }

    if (
      Flagship.config.records[this.type].extra1.required === true &&
      this.props.userRole ===
        Flagship.config.records[this.type].extra1.role_required &&
      empty(self.state.extra1)
    ) {
      requiredMissing = true;
    }

    if (
      Flagship.config.records[this.type].extra2.required === true &&
      this.props.userRole ===
        Flagship.config.records[this.type].extra2.role_required &&
      empty(self.state.extra2)
    ) {
      requiredMissing = true;
    }

    if (
      Flagship.config.records[this.type].extra3.required === true &&
      this.props.userRole ===
        Flagship.config.records[this.type].extra3.role_required &&
      empty(self.state.extra3)
    ) {
      requiredMissing = true;
    }

    if (
      Flagship.config.records[this.type].extra4 &&
      Flagship.config.records[this.type].extra4.required === true &&
      this.props.userRole ===
        Flagship.config.records[this.type].extra4.role_required &&
      empty(self.state.extra4)
    ) {
      requiredMissing = true;
    }

    this.state.recordFields.map(function (item) {
      if (
        (item.required === true || item.required === 1) &&
        empty(self.state.fieldData[item.field_id]) &&
        shouldShowField(item, self.state.fieldData)
      ) {
        requiredMissing = true;
      }
    });

    this.setState({
      requiredMissing: requiredMissing,
    });
  }

  onChange(e, newFieldValue, fieldId) {
    let newFieldData = [...this.state.fieldData];

    newFieldData[fieldId] = newFieldValue;

    window.onbeforeunload = function (e) {
      let text = "Are you sure you want to leave Flagship?";
      e.returnValue = text;
      return text;
    };

    this.setState(
      {
        modified: true,
        fieldData: newFieldData,
      },
      this.checkRequired
    );
  }

  showLeaveConfirmation(nextLocation) {
    this.setState({
      confirmExit: true,
      nextLocation: nextLocation,
    });
  }

  saveRecord(callback = null) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;

    if (this.state.requiredMissing === false) {
      //Save
      Flagship.post(
        "create-record/" + this.type,
        {
          market: self.state.selectedMarket,
          type: this.type,
          record_status: Flagship.config.records[this.type].defaultStatus,
          creator: self.props.userId,
          record_name: self.state.name,
          extra1: self.state.extra1,
          extra2: self.state.extra2,
          extra3: self.state.extra3,
          extra4: self.state.extra4,
          fields: self.state.fieldData,
          parent: self.state.parent,
        },
        function (response) {
          if (response.data.success === true) {
            if (typeof callback === "function") {
              callback(response);
            }
          } else {
            Flagship.error(
              "Failed to save record.",
              response.data.record_id,
              self.props.userId
            );
          }
        },
        function (err) {
          Flagship.error("Failed to save record: " + err, 0, self.props.userId);
        }
      );
    } else {
      Flagship.notify("Sorry, one or more required fields are blank.", "error");
    }
  }

  onChangeName(e) {
    this.setState(
      {
        name: e.target.value,
      },
      this.checkRequired
    );

    let self = this;

    this.timer = throttle(
      function () {
        Flagship.get(
          "validate/" + self.type + "-name",
          { value: e.target.value },
          function (response) {
            if (response.data.success === true) {
              let errors = [...self.state.errors];
              for (let i in errors) {
                if (errors[i] === "recordName") {
                  errors.splice(i, 1);
                }
              }
              self.setState({
                validName: true,
                nameValidationMessage:
                  self.state.nameValidationMessage === ""
                    ? ""
                    : response.data.message,
                errors: errors,
              });
            } else {
              let errors = [...self.state.errors, "recordName"];
              self.setState({
                validName: false,
                nameValidationMessage: response.data.message,
                errors: errors,
              });
            }
          },
          function (err) {
            Flagship.error(
              "Failed to validate name on new " +
                self.type +
                " creation: " +
                err,
              0,
              self.props.userId
            );
          }
        );
      },
      500,
      this.timer
    );
  }

  onSubmit() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;

    this.saveRecord(function (response) {
      window.onbeforeunload = null;

      self.setState({
        confirmExit: false,
        modified: false,
      });

      if (response.data.success === true) {
        Flagship.notify(self.niceName + " created.", "success");

        if (self.type === "client") {
          Flagship.event(
            "create-" + self.type,
            {
              name: self.state.name,
              extra1: self.state.extra1,
              extra2: self.state.extra2,
              extra3: self.state.extra3,
              extra4: self.state.extra4,
              key: response.data.record_key,
              type: self.type,
            },
            response.data.record_id,
            self.props.userId
          );
        }

        let newRecordLink =
          "/" + self.type + "/view/" + response.data.record_key;

        if (!empty(self.props.route)) {
          browserHistory.push(newRecordLink);
        } else {
          self.props.onAddRecord(
            response.data.record_id,
            newRecordLink,
            response.data.record_key,
            self.state.name,
            self.state.selectedMarket
          );
        }
      } else {
        Flagship.error(
          "Could not create new " + self.niceName + " record.",
          0,
          self.props.userId
        );
        Flagship.notify("Error creating " + self.niceName + ".", "error");
      }
    });
  }

  cancelExit() {
    this.setState({
      confirmExit: false,
    });
  }

  abandonChanges() {
    let newLocation = this.state.nextLocation;
    this.setState(this.getInitialState(), function () {
      if (newLocation) {
        browserHistory.push(newLocation);
      }
    });
  }

  onChangeMarket(e, data) {
    this.setState(
      {
        selectedMarket: data,
      },
      this.checkRequired
    );
  }

  onChangeExtra1(e, data) {
    if (this.type === "io" && data.id === 1) {
      // Advisr proposal

      this.setState(
        {
          extra1: data,
          selectedMarket: this.props.userMarket,
          isAdvisr: true,
        },
        this.checkRequired
      );
    } else if (this.type !== "client" && !empty(data.market)) {
      this.setState(
        {
          extra1: data,
          selectedMarket: data.market,
          isAdvisr: false,
        },
        this.checkRequired
      );
    } else {
      this.setState(
        {
          extra1: data,
          isAdvisr: false,
        },
        this.checkRequired
      );
    }
  }

  onChangeExtra2(e, data) {
    this.setState(
      {
        extra2: data,
      },
      this.checkRequired
    );
  }

  onChangeExtra3(e, data) {
    this.setState(
      {
        extra3: data,
      },
      this.checkRequired
    );
  }

  onChangeExtra4(e, data) {
    this.setState(
      {
        extra4: data,
        parent: data.id,
      },
      this.checkRequired
    );
  }

  onChangeProductData(e, data, fieldId) {
    let fieldData = [...this.state.fieldData];

    fieldData[fieldId] = data;

    this.setState({
      fieldData,
    });
  }

  onChildRequiredMissing() {
    this.setState({
      childRequiredMissing: true,
    });
  }

  maybeRenderExtra1() {
    if (empty(Flagship.config.records[this.type].extra1)) {
      return null;
    }

    if (
      !empty(this.state.formTemplate) &&
      !empty(this.state.formTemplate.extra1)
    ) {
      if (this.type === "io") {
        return (
          <div className="field-container clearfix">
            <Label className="multi-field-label clearfix" size="large">
              RFP Selected
            </Label>
            <Segment style={{ margin: ".5em 0" }} compact>
              <Header as="h3">
                <Icon
                  className="feed-icon"
                  disabled
                  size="large"
                  color="grey"
                  name="dollar"
                />
                {this.state.isAdvisr ? (
                  <div>
                    <h2>Advisr Proposal</h2>
                    <p>
                      Please upload the IO spreadsheet from Advisr under "Files"
                      below.
                    </p>
                  </div>
                ) : (
                  <Link to={"/rfp/view/" + this.state.formTemplate.extra1.key}>
                    #{this.state.formTemplate.extra1.key}
                  </Link>
                )}
              </Header>
              <Header style={{ marginTop: "0px" }} as="h4">
                {this.state.formTemplate.extra1.name}
              </Header>
            </Segment>
          </div>
        );
      } else {
        return (
          <div className="field-container clearfix">
            <Label className="multi-field-label clearfix" size="large">
              Client Selected
            </Label>
            <Segment style={{ margin: ".5em 0" }} compact>
              <Header as="h3">
                <Icon
                  className="feed-icon"
                  disabled
                  size="large"
                  color="grey"
                  name="briefcase"
                />
                <Link to={"/client/view/" + this.state.formTemplate.extra1.key}>
                  #{this.state.formTemplate.extra1.key}
                </Link>
              </Header>
              <Header style={{ marginTop: "0px" }} as="h4">
                {this.state.formTemplate.extra1.name}
              </Header>
            </Segment>
          </div>
        );
      }
    }

    let value = this.state.extra1;
    if (
      typeof value === "string" &&
      Flagship.config.records[this.type].extra1.multi === true
    ) {
      value = [value];
    }

    return (
      <Field
        id="extra1"
        addError={this.addError.bind(this)}
        clearError={this.clearError.bind(this)}
        model="createRecord.extra1"
        active="1"
        name="recordExtra1"
        value={value}
        onChange={this.onChangeExtra1}
        {...Flagship.config.records[this.type].extra1}
      />
    );
  }

  maybeRenderExtra2() {
    if (empty(Flagship.config.records[this.type].extra2)) {
      return null;
    }

    let value = this.state.extra2.value;
    if (
      typeof value === "string" &&
      Flagship.config.records[this.type].extra2.multi === true
    ) {
      value = [value];
    }

    if (typeof value === "undefined") {
      value = null;
    }

    return (
      <Field
        id="extra2"
        addError={this.addError.bind(this)}
        clearError={this.clearError.bind(this)}
        model="createRecord.extra2"
        active="1"
        name="recordExtra2"
        value={value}
        onChange={this.onChangeExtra2}
        {...Flagship.config.records[this.type].extra2}
      />
    );
  }

  maybeRenderExtra3() {
    if (
      empty(Flagship.config.records[this.type].extra3) ||
      !this.state.isAdvisr
    ) {
      return null;
    }

    let value = this.state.extra3;
    if (
      typeof value === "string" &&
      Flagship.config.records[this.type].extra3.multi === true
    ) {
      value = [value];
    }
    return (
      <Field
        id="extra3"
        addError={this.addError.bind(this)}
        clearError={this.clearError.bind(this)}
        model="createRecord.extra3"
        active="1"
        name="recordExtra3"
        value={value}
        onChange={this.onChangeExtra3}
        {...Flagship.config.records[this.type].extra3}
      />
    );
  }

  maybeRenderExtra4() {
    if (
      empty(Flagship.config.records[this.type].extra4) ||
      (!this.state.isAdvisr && this.type !== "client")
    ) {
      return null;
    }

    let value = this.state.extra4;
    if (
      typeof value === "string" &&
      Flagship.config.records[this.type].extra4.multi === true
    ) {
      value = [value];
    }
    return (
      <Field
        id="extra4"
        addError={this.addError.bind(this)}
        clearError={this.clearError.bind(this)}
        model="createRecord.extra4"
        active="1"
        name="recordExtra4"
        value={value}
        onChange={this.onChangeExtra4}
        {...Flagship.config.records[this.type].extra4}
      />
    );
  }

  render() {
    if (
      this.type === "rfp" &&
      this.props.userMarket !== "Chicago" &&
      this.props.instance !== "SHIFT"
    )
      return (
        <div className="fade-in">
          <Table>
            <Table.Body>
              <Table.Row>
                <Table.Cell colSpan="5">
                  <div style={{ padding: "1rem" }}>
                    <h1>RFP Creation Disabled.</h1>
                    <p>
                      Sorry, you can no longer add new RFPs to Flagship. Please
                      use Advisr going forward.
                    </p>
                  </div>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      );
    if (empty(this.state.recordFields) || this.state.recordFields === false) {
      return (
        <div className="fade-in">
          <SingleRecordHeader
            recordName={
              this.state.name === "" ? "New " + this.niceName : this.state.name
            }
            recordType={this.type}
            recordStatus="draft"
            recordMarket={this.state.selectedMarket}
            creatorFirstName={this.props.userFirstName}
            creatorLastName={this.props.userLastName}
            creatorPhoto={this.props.userPhoto}
          />
          <Table>
            <Table.Body>
              <Table.Row>
                <Table.Cell colSpan="5">
                  <Loader className="flagship-loader" active inline="centered">
                    Loading...
                  </Loader>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      );
    } else {
      let self = this;
      return (
        <div className="fade-in">
          {!empty(this.props.router) ? (
            <SingleRecordHeader
              recordName={
                this.state.name === ""
                  ? "New " + this.niceName
                  : "New " + this.niceName + ": " + this.state.name
              }
              recordType={this.type}
              recordStatus="draft"
              recordMarket={this.state.selectedMarket}
              creatorFirstName={this.props.userFirstName}
              creatorLastName={this.props.userLastName}
              creatorPhoto={this.props.userPhoto}
            />
          ) : null}

          <Header className="cf" attached="top">
            <h2>
              {(this.mode === "edit" ? "Editing " : "") +
                this.niceName +
                " Details "}
            </h2>
            <Button
              floated="right"
              disabled={
                self.state.requiredMissing || self.state.errors.length
                  ? true
                  : false
              }
              primary
              onClick={this.onSubmit}
              content="Create"
            />
            {self.state.requiredMissing ? (
              <span className="float-right required-missing-header">
                Required Fields Missing.
              </span>
            ) : null}
            {self.state.errors.length ? (
              <span className="float-right form-errors-header">
                Invalid Field Value.
              </span>
            ) : null}
          </Header>

          <Segment className="record-main" attached>
            <Grid stackable>
              <Grid.Column width={12}>
                <Field
                  addError={this.addError.bind(this)}
                  clearError={this.clearError.bind(this)}
                  id="recordName"
                  model="createRecord.0"
                  label="Name"
                  active="1"
                  default=""
                  details=""
                  required="1"
                  index="0"
                  multi="0"
                  name="recordName"
                  value={this.state.name}
                  placeholder={"New " + this.niceName}
                  onChange={this.onChangeName}
                  type="text"
                />

                {this.state.nameValidationMessage !== "" ? (
                  <Label
                    color={this.state.validName === false ? "red" : "green"}
                    className={
                      this.state.validName === false
                        ? "flagship-field-error-message"
                        : ""
                    }
                    pointing
                  >
                    <div className="flexbox">
                      <div className="top" />
                      <div className="middle">
                        {this.state.nameValidationMessage}
                      </div>
                      <div className="bottom" />
                    </div>
                  </Label>
                ) : null}
                <div>
                  {this.type === "client" ? (
                    <Field
                      addError={this.addError.bind(this)}
                      clearError={this.clearError.bind(this)}
                      id="recordMarket"
                      model="createRecord.market"
                      label="Market"
                      active="1"
                      default=""
                      details=""
                      required="1"
                      index="0"
                      multi="0"
                      name="recordMarket"
                      value={this.state.selectedMarket}
                      options={Flagship.config.markets}
                      onChange={this.onChangeMarket}
                      type="select"
                    />
                  ) : null}

                  {this.maybeRenderExtra1()}
                  {this.maybeRenderExtra4()}
                  {this.maybeRenderExtra2()}
                  {this.niceName === "IO" ? this.maybeRenderExtra3() : null}

                  {this.state.recordFields.map(function (item) {
                    let fieldId = item.field_id;

                    item = clean(item);

                    return shouldShowField(item, self.state.fieldData) ? (
                      <Field
                        addError={self.addError.bind(self)}
                        clearError={self.clearError.bind(self)}
                        model={"createRecord." + item.field_id}
                        value={item.default}
                        index={fieldId}
                        filterInput={
                          item.validation !== "" ? item.validation : null
                        }
                        key={"field-" + fieldId}
                        onChange={(e, value) =>
                          self.onChange(e, value, fieldId)
                        }
                        {...item}
                      />
                    ) : null;
                  })}
                  {this.niceName === "IO" ? (
                    <IoProductFields
                      service={this.state.extra3}
                      onChange={this.onChangeProductData}
                    />
                  ) : (
                    this.maybeRenderExtra3()
                  )}

                  <br />
                  <Button
                    disabled={
                      self.state.requiredMissing || self.state.errors.length
                        ? true
                        : false
                    }
                    primary
                    onClick={self.onSubmit}
                    content="Create"
                  />
                  {self.state.requiredMissing ? (
                    <span>
                      {" "}
                      Please fill out all required fields before submitting.
                    </span>
                  ) : null}
                  {self.state.errors.length ? (
                    <span> Please correct errors before submitting.</span>
                  ) : null}
                </div>
                {this.state.confirmExit === true ? (
                  <Modal open={true} onClose={this.cancelExit} closeIcon>
                    <Header icon="save" content="Save Changes?" />
                    <Modal.Content>
                      <p>
                        You have unsaved changes. What would you like to do?
                      </p>
                    </Modal.Content>
                    <Modal.Actions>
                      <Button primary onClick={this.saveAndExit}>
                        <Icon name="save" /> Save Changes
                      </Button>
                      <Button secondary onClick={this.abandonChanges}>
                        <Icon name="cancel" /> Abandon Changes
                      </Button>
                      <Button color="grey" onClick={this.cancelExit}>
                        <Icon name="dont" /> Cancel
                      </Button>
                    </Modal.Actions>
                  </Modal>
                ) : null}
              </Grid.Column>
              <Grid.Column width={4}>
                <Segment>
                  <Header>{this.niceName} not yet created.</Header>
                  <p>You'll be able to do more once you click "Create."</p>
                </Segment>
              </Grid.Column>
            </Grid>
          </Segment>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    token: state.main.token,
    username: state.main.username,
    userId: state.main.userId,
    userFirstName: state.main.userFirstName,
    userLastName: state.main.userLastName,
    userPhoto: state.main.userPhoto,
    userMarket: state.main.userMarket,
    userRole: state.main.userRole,
    accessLevel: state.main.accessLevel,
    instance: state.main.instance,
    formTemplate: state.main.formTemplate,
  };
}

export default connect(mapStateToProps, null)(CreateRecord);



// WEBPACK FOOTER //
// ./src/components/views/CreateRecord.js